import {createContext} from 'react';

export type PostHandler = () => void;

type VerificationCompletedProps = {
  openModal: (proceed: PostHandler) => void;
  closeModal: () => void;
  proceed: PostHandler;
};

export const VerificationCompletedContext = createContext<VerificationCompletedProps>({
  closeModal: () => {},
  openModal: () => {},
  proceed: () => {},
});
